import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const PageNavigation = ({ title }) => {
  return (
    <Wrapper>
      <NavLink to="/">Home </NavLink>/ {title}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  height: 4rem;
  background-color: #232f3e;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 2rem;
  padding-left: 1.2rem;
  color: white;
  a {
    font-size: 2rem;
    color: #ffde59;

  }
`;

export default PageNavigation;